import { Logger } from '../../02_utils/logger';
import { Utils } from '../../02_utils/utils';
import fitty from 'fitty';

export class Hero {
  constructor(private $logger: Logger, private $utils: Utils) {
    const fitties = fitty('.js-full-width-text', {
      minSize: 20,
      multiLine: false
    });

    fitties.forEach((f) => {
      f.fit({ sync: true });
    });
  }
}
